import { guid } from "../../../core/helpers/string-util.js";
import Model from "../../Model.js";

/**
 * A formula token represents a lexical item of a mathematical expression.
 *
 * Formula tokens are built from a formula node tree by a `FormulaNodeTokenizer`.
 */
export default class AbstractFormulaToken extends Model {
	constructor() {
		super(...arguments);
		this._id = guid();
	}

	getId() {
		return this._id;
	}

	getLabel() {
		return this.constructor.getLabel();
	}

	getType() {
		return this.constructor.getType();
	}

	asFormulaNode() {
		this._subclassResponsibility();
	}

	hasPeriodFilter() {
		return false;
	}

	isOpeningParenthesis() {
		return false;
	}

	isClosingParenthesis() {
		return false;
	}

	isParenthesis() {
		return this.isOpeningParenthesis() || this.isClosingParenthesis();
	}

	isBinaryOperator() {
		return false;
	}

	isOperator() {
		return this.isParenthesis() || this.isBinaryOperator();
	}

	accept(visitor) {
		return visitor.visitAbstractFormulaToken(this);
	}

	static getLabel() {
		return "";
	}

	static getType() {
		return "";
	}

	static newDefault(_context) {
		return new this();
	}
}
